export const TOP_MENU_LANG_MODAL_OPEN_EVENT_UA = ["clicked", "TopMenu", "OpenModal"] as const;
export const TOP_MENU_LANG_MODAL_OPEN_EVENT = { event: "cta_click", label: "open_modal", placement: "top_menu" } as const;

export const VIEW_CLAIM_STATUS_EVENT_UA = ["clicked", "TopMenu", "CheckYourCompensation"] as const;
export const VIEW_CLAIM_STATUS_EVENT = { event: "cta_click", label: "check_your_compensation", placement: "top_menu" } as const;
